import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66f3ef45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Process")
  ])
], -1))
const _hoisted_3 = { class: "card justify-center items-center flex mt-4" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex flex-col w-full bg-white min-h-320" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex p-5 border-b border-solid border-lightgrey rounded-t" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "formcontainer flex mr-2" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Create Process")
  ])
], -1))
const _hoisted_7 = { class: "p-2 mt-4" }
const _hoisted_8 = { class: "flex justify-between w-100 gap-3" }
const _hoisted_9 = { class: "w-1/2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm" }, "Process", -1))
const _hoisted_11 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_12 = {
  key: 0,
  class: "error-text"
}
const _hoisted_13 = { class: "w-1/2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm" }, "Please select workflow to proceed:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Please select one", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_18 = {
  key: 0,
  class: "error-text"
}
const _hoisted_19 = { class: "flex justify-between w-100 gap-3" }
const _hoisted_20 = { class: "w-1/2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Target Audience", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10501" }, "Everyone", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10502" }, "Team(s)", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_26 = {
  key: 0,
  class: "error-text"
}
const _hoisted_27 = { class: "w-1/2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "End user departments:", -1))
const _hoisted_29 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_30 = {
  key: 0,
  class: "error-text"
}
const _hoisted_31 = { class: "flex justify-between w-100" }
const _hoisted_32 = { class: "w-1/2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Task team / owner:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Please select one", -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_37 = {
  key: 0,
  class: "error-text"
}
const _hoisted_38 = { class: "flex items-end justify-end mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.process.name) = $event)),
                  class: _normalizeClass(["inputboxstyling", {
										'is-invalid': _ctx.v$.process.name.$error
									}])
                }, null, 2), [
                  [_vModelText, _ctx.process.name]
                ]),
                (_ctx.v$.process.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.v$.process.name.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["inputboxstyling", {
										'is-invalid': _ctx.v$.process.mappedWorkflow.$error
									}]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.process.mappedWorkflow) = $event))
                }, [
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflows, (workflow) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: workflow._id,
                      key: workflow._id
                    }, _toDisplayString(workflow.workFlowName), 9, _hoisted_16))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _ctx.process.mappedWorkflow]
                ]),
                (_ctx.v$.process.mappedWorkflow.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_ctx.v$.process.mappedWorkflow.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["inputboxstyling", {
										'is-invalid': _ctx.v$.process.targetAudience.$error
									}]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.process.targetAudience) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTarget(_ctx.process)))
                }, _hoisted_24, 34), [
                  [_vModelSelect, _ctx.process.targetAudience]
                ]),
                (_ctx.v$.process.targetAudience.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_ctx.v$.process.targetAudience.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.process.endUsersDepartment,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.process.endUsersDepartment) = $event)),
                  options: _ctx.teamsarray,
                  showNoOptions: false,
                  multiple: true,
                  "close-on-select": true,
                  "clear-on-select": true,
                  "hide-selected": true,
                  "open-direction": "bottom",
                  label: "label",
                  "track-by": "value",
                  searchable: true,
                  hideArrow: false,
                  placeholder: "Departments",
                  class: _normalizeClass(["custom-multiselect userSelect", {
									'is-invalid borderRed': _ctx.v$.process.endUsersDepartment.$error
									}])
                }, null, 8, ["modelValue", "options", "class"]),
                (_ctx.v$.process.endUsersDepartment.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_ctx.v$.process.endUsersDepartment.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["inputboxstyling", {
										'is-invalid': _ctx.v$.process.taskOwnersDepartment.$error
									}]),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.process.taskOwnersDepartment) = $event))
                }, [
                  _hoisted_34,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: team,
                      key: team._id
                    }, _toDisplayString(team.teamName), 9, _hoisted_35))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _ctx.process.taskOwnersDepartment]
                ]),
                (_ctx.v$.process.taskOwnersDepartment.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_ctx.v$.process.taskOwnersDepartment.required.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              (_ctx.pageType == 'create')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btnprimary",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveProcess(_ctx.process)))
                  }, "Save"))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btnprimary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateProcess(_ctx.process)))
                  }, "Update"))
            ])
          ])
        ])
      ])
    ])
  ]))
}